import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
// Modules
import { TranslateModule } from '@ngx-translate/core';
import { AgmOverlays } from 'agm-overlays';
import { NgAisModule } from 'angular-instantsearch';
import { AutocompleteSeachComponent } from './components/autocompleteSeach/autocompleteSeach.component';
import { AutocompleteSeachServiceComponent } from './components/autocompleteSeachService/autocompleteSeach-service.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormLoginComponent } from './components/navbar/components/formLogin/formLogin.component';
// Components
import { NavbarComponent } from './components/navbar/navbar.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
// Layouts
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { MaterialModule } from './shared/material.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppLayoutComponent,
    LoginLayoutComponent,
    NavbarComponent,
    FormLoginComponent,
    ChatbotComponent,
    FooterComponent,
    AutocompleteSeachComponent,
    AutocompleteSeachServiceComponent
  ],
  imports: [
    DashboardRoutingModule,
    CommonModule,
    TranslateModule,
    AgmCoreModule,
    AgmOverlays,
    NgAisModule,
    MaterialModule,
    SharedModule,
    AngularEditorModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule {}
